import styled from '@emotion/styled'
import { Colors } from '~/assets/style/colors'
import { Fonts } from '~/assets/style/fonts'
import TableCell from '~/components/table/TableCell'

export const ActionsTableCell = styled(TableCell)`
  width: 0px; /** necessary to get the last cell to shrink down to hug action buttons */
`

export const ActionButtons = styled.div`
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
`

export const FilterAction = styled.form`
  margin: 12px 0px;
  display: flex;
`

/** The muted em dash a cell shows for a value that is not there. One place, so every column draws the same nothing. */
export const AbsentValue = styled.span`
  color: ${Colors.Ash};
`

export const NoResultsTableCell = styled(TableCell)`
  ${Fonts.colors.SlateGrey}
  font-style: italic;
`
